import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import {
  GetOpenFormatDataRequest,
  ExportOpenFormatFilesResponse,
  GetOpenFormatSummaryResponse,
} from "../../models/OpenFormat.model";

const API_BASE_URL = environment.apiUrl;

export const exportOpenFormatFiles = createAsyncThunk<
  ExportOpenFormatFilesResponse,
  GetOpenFormatDataRequest,
  { rejectValue: string }
>(
  "openFormat/exportOpenFormatFiles",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}OpenFormatData/ExportOpenFormatFiles`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const contentType = response.headers.get("Content-Type") || "";
      const blob = await response.blob();
      const contentDisposition = response.headers.get("Content-Disposition") || "";
      const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      const fileName = fileNameMatch ? fileNameMatch[1].replace(/['"]/g, "") : "open-format.zip";

      return { success: true, message: "", fileName, blob, contentType };
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "שגיאה בייצוא קבצי פורמט אחיד",
      );
    }
  },
);

export const exportAndDownloadOpenFormatFiles = createAsyncThunk<
  string,
  GetOpenFormatDataRequest,
  { rejectValue: string }
>(
  "openFormat/exportAndDownloadOpenFormatFiles",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}OpenFormatData/ExportOpenFormatFiles`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const contentDisposition = response.headers.get("Content-Disposition") || "";
      const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      const fileName = fileNameMatch ? fileNameMatch[1].replace(/['"]/g, "") : "open-format.zip";

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);

      return fileName;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "שגיאה בהורדת קבצי פורמט אחיד",
      );
    }
  },
);

export const getOpenFormatSummary = createAsyncThunk<
  GetOpenFormatSummaryResponse,
  GetOpenFormatDataRequest,
  { rejectValue: string }
>(
  "openFormat/getOpenFormatSummary",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}OpenFormatData/GetOpenFormatSummary`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        },
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const data = await response.json();
      return data as GetOpenFormatSummaryResponse;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "שגיאה בטעינת סיכום פורמט אחיד",
      );
    }
  },
);
